<div class="text-center" *ngIf="jsonControl?.value" style="display: flex; align-items: center;">
  <div style="flex-grow: 1">
    <app-document-summary-field *ngIf="document else noDocument" [documentSummary]="document"></app-document-summary-field>
    <ng-template #noDocument>
      Un fichier PDF existe déjà
    </ng-template>
  </div>
  <app-button fill="solid" iconName="trash" (clickEvent)="reset()" size="small" style="flex-grow: 0;"></app-button>
</div>
<app-file-upload #fileUpload *ngIf="!jsonControl.value"
                 [allowedFileExtensions]="['pdf']"
                 [maxFileCount]="1"
                 (filedAddedEvent)="onFileAdded($event)"
></app-file-upload>
